<template>
  <div class="center-outer">

    <div class="statistics-list-outer">
      <StatisticsItem :icon-src="require('@/assets/images/icon_1.png')" :num="79322" title="资源性资产" :unit="'个'" />
      <StatisticsItem :icon-src="require('@/assets/images/icon_2.png')" :num="26494" title="固定资产" :unit="'个'" />
      <StatisticsItem :icon-src="require('@/assets/images/icon_3.png')" :num="1102" title="其他资产" :unit="'个'" />
    </div>

    <MiddleMap />

    <!-- <div class="bottom-list-outer">
      <BottomItem :bgSrc="require('@/assets/images/bg_分中心.png')" color="#00FBFF" title="分中心" :num="statisData.centerCnt-0"/>
      <BottomItem :bgSrc="require('@/assets/images/bg_服务站.png')" color="#00B0FF" title="服务站" :num="statisData.siteCnt-0"/>
      <BottomItem :bgSrc="require('@/assets/images/bg_服务点.png')" color="#02E6A9" title="服务点" :num="statisData.pointCnt-0"/>
    </div> -->

  </div>
</template>

<script>
import StatisticsItem from './StatisticsItem.vue'
import MiddleMap from './MiddleMap.vue'
import BottomItem from './BottomItem.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    StatisticsItem,
    MiddleMap,
    BottomItem
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['statisData'])
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.center-outer{
  display: flex;
  flex-direction: column;
}
.statistics-list-outer{
  display: flex;
  justify-content: space-between;
}
.bottom-list-outer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
}
</style>
